import { createLoadingReducer } from './utils';

export default createLoadingReducer('CODELOCK_SETTINGS');
